import { FeatureLaunch, isFeatureLaunched } from '@commenda/feature-launches';
import { Loading } from '@commenda/kakashi';
import { HomeScreenDashboard } from 'components/HomeScreen/HomeScreenDashboard';
import HomeScreenForAffiliates from 'components/HomeScreen/HomeScreenForAffiliates';
import { NewHomeScreen } from 'components/NewHomeScreen';
import { useConfig } from 'context/useConfig';

const Home = () => {
  const { isLoading: isConfigLoading, activeView } = useConfig();

  if (isConfigLoading) {
    return (
      <div className="h-screen w-screen flex items-center justify-center">
        <Loading />
      </div>
    );
  }

  if (activeView === 'AFFILIATE') return <HomeScreenForAffiliates />;

  if (isFeatureLaunched(FeatureLaunch.NEW_HOME_SCREEN))
    return <NewHomeScreen />;

  return <HomeScreenDashboard />;
};

export default Home;
